import { CarrierInformationProvider } from 'components/MerchantTrackingWidget/context';
import { ShipmentLayout } from '../../../../../ShipmentLayout';
import { ShipmentDetails } from '../../../ShipmentDetails';

import { ReturnShipment as ReturnShipmentModel } from '../../../../models/ReturnShipment.model';
import { useCurrentShipment } from '../../../../../../hooks/useCurrentShipment';
import { PreprintedTrackingDetails } from './PreprintedTrackignDetails';

interface PreprintedLabelReturnShipmentProps {
  hasMultipleShipments: boolean;
}

export const PreprintedLabelReturnShipment = ({
  hasMultipleShipments,
}: PreprintedLabelReturnShipmentProps) => {
  const { shipment } = useCurrentShipment();
  const returnShipment = ReturnShipmentModel.create(shipment);

  const parcelDetails = <ShipmentDetails shipment={returnShipment} />;

  const trackingDetails = (
    <PreprintedTrackingDetails
      shipment={shipment}
      hasMultipleShipments={hasMultipleShipments}
    />
  );

  return (
    <CarrierInformationProvider shipment={shipment}>
      <ShipmentLayout
        parcelDetails={parcelDetails}
        trackingDetails={trackingDetails}
      />
    </CarrierInformationProvider>
  );
};
